import countriesData from '@/generated/countries.json'
import { CountryCode, Currency, Language } from '@/generated/graphql'

import { z } from 'zod'

const countrySchema = z.object({
  name: z.string(),
  code: z.nativeEnum(CountryCode),
  currency: z.nativeEnum(Currency),
  flagImageUri: z.object({
    square: z.string(),
    rectangle: z.string(),
  }),
  defaultLanguage: z.string(),
  languages: z.array(z.nativeEnum(Language)),
  locales: z.array(z.string()),
})

export const countries = countriesData.map((country) => countrySchema.parse(country))
